"use client";
import { useRef, useState } from "react";
import { usePathname } from "next/navigation";

function useNavbar() {
  const currentPath = usePathname();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const OfferNavRef = useRef<any>(null);

  const handleMenuToggle = (isOpen: boolean) => {
    setIsMenuOpen(isOpen);
  };

  const navItems = [
    {
      label: "About Us",
      href: "/about-us",
    },
    {
      label: "Blog",
      href: "/blog",
    },
    {
      label: "Contact Us",
      href: "/contact-us",
    },
  ];
  const navMenuItems = [
    {
      label: "About Us",
      href: "/about-us",
    },
    {
      label: "Contact Us",
      href: "/contact-us",
    },
    {
      label: "Blog",
      href: "/blog",
    },
  ];

  return {
    navItems,
    navMenuItems,
    isMenuOpen,
    currentPath,
    OfferNavRef,
    handleMenuToggle,
  };
}
export default useNavbar;
